<div id="dialogbox">
    <div class="dialogflex-form btn_focus_11">
        <div>
            <header>
                <div class="row">
                    <div class="col-md-7">
                        <div class="nunito mb-0">
                        </div>
                    </div>
                </div>
            </header>
            <section class="edit-scroll">
                <div class="section-form errorlist">
                    <div class="row" style="margin-right: -6px;">
                        <div class="col-md-12 inbox-padd1">
                            <h2 class="heading2 mb-3 mt-2">Validations</h2>
                            <h3 class="heading4 mb-2">{{this.local_data.title}}</h3>
                            <div *ngFor="let data of local_data.showValidation">
                                <ul class="inner-panel-list-box d-flex align-items-center justify-content-between">
                                    <li class="error-list1">
                                        <span class="d-flex">
                                            <mat-icon class="error-icon me-1">error</mat-icon>
                                            <span style="margin-left: 5px;">{{data}}</span>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <!-- <div>
                                <ul class="inner-panel-list-box d-flex align-items-center justify-content-between">
                                    <li class="error-list2">
                                        <span class="d-flex">
                                            <mat-icon class="error-warning-icon me-1">warning</mat-icon>
                                            <span>Please Define User Name</span>
                                        </span>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="section-form" [hidden]="local_data.showValidation.length>0">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="justify-content-center d-flex" style="margin: 30% 0% 0% 0%;">
                                <span style="font-size: 34px;
                                font-weight: lighter;"> No Data Found...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<!-- <p>validations works!</p>
<div *ngFor="let msg of this.local_data.showValidation">
   
</div> -->

